import React from 'react';
import SEO from '../components/SEO';
import './OddsCalculatorPage.css'; // We will create this for page-specific styles

function OddsCalculatorPage() {
  const calculatorSchema = {
    "@context": "https://schema.org",
    "@type": "WebApplication",
    "name": "Texas Hold'em Poker Odds Calculator",
    "description": "Calculate poker hand odds and equity in Texas Hold'em. Free online tool for pot odds and winning probability calculations.",
    "applicationCategory": "UtilityApplication",
    "browserRequirements": "Requires JavaScript",
    "offers": {
      "@type": "Offer",
      "price": "0",
      "priceCurrency": "USD"
    }
  };

  return (
    <>
      <SEO 
        title="Poker Odds Calculator - Texas Hold'em Equity & Pot Odds"
        description="Free poker odds calculator for Texas Hold'em. Calculate hand equity, pot odds, and winning percentages instantly. Essential tool for GTO poker strategy."
        keywords="poker odds calculator, texas holdem calculator, pot odds, poker equity, hand odds calculator"
        canonical="https://gtopre.com/odds_calculator"
        schema={calculatorSchema}
      />
      <div className="odds-calculator-page">
        <h1>Texas Hold'em Poker Odds Calculator</h1>
        {/* Placeholder for the calculator UI */}
        <p>Odds Calculator UI will go here.</p>
      </div>
    </>
  );
}

export default OddsCalculatorPage; 